import { icons } from '../../assets/assets';
import GameMaterialItem from './GameMaterialItem';

export default class DocumentGameMaterial extends GameMaterialItem {
  constructor(props) {
    super(props);
    this.state.icons = [icons.pdf];
    if (this.props.item.printable) {
      this.state.icons.unshift(icons.print);
    }
    this.handleClick = (ev) => {
      const { item } = this.props;
      if (!item.Material) return;
      window.open(item.Material.url, '_blank');
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/elements/DocumentGameMaterial.js